export default "__VITE_PUBLIC_ASSET__a7f13846__"